export default __webpack_public_path__ + "37150c1132b737ee3284ac0df10664b5.svg";